import { CatalogFilter, CourseCatalog } from '../types';
import { post } from '../utils';
import { Dispatch, UnknownAction } from 'redux';

const UPDATE = 'UPDATE_CATALOG';

interface CatalogAction extends UnknownAction {
  catalog: CourseCatalog[];
}

export function catalogReducer(catalog: CourseCatalog[] = [], action: CatalogAction): CourseCatalog[] {
  if (action.type === UPDATE) {
    return action.catalog;
  }
  return catalog;
}

function appendForm(form, field, value): void {
  if (value) {
    form.append(field, value);
  }
}

export const fetchCatalogAction =
  (dispatch: Dispatch) =>
  ({ organizationId, typeId, fromDate, toDate, tag, webTypeId }: CatalogFilter): void => {
    const form = new FormData();
    appendForm(form, 'organizationId', organizationId);
    appendForm(form, 'typeId', typeId);
    appendForm(form, 'fromDate', fromDate);
    appendForm(form, 'toDate', toDate);
    appendForm(form, 'tag', tag);
    appendForm(form, 'webTypeId', webTypeId);
    post<CourseCatalog[]>('/aktiviteter/api/catalog', form)
      .then((catalog: CourseCatalog[]) => {
        dispatch({ type: UPDATE, catalog });
      })
      .catch((ex) => {
        console.error('Failed to fetch catalog', ex);
      });
  };
